import { add } from "lodash";

// local state
const getDefaultState = () => {
	return {
		controllingCombo_index: 0,
		//controllingCombo: ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
		controllingCombo: [{ value: 'A', text: 'A' }, { value: 'B', text: 'B' }, { value: 'C', text: 'C' }, { value: 'D', text: 'D' }, { value: 'E', text: 'E' }, { value: 'F', text: 'F' }, { value: 'G', text: 'G' }, { value: 'H', text: 'H' }, { value: 'I', text: 'I' }, { value: 'J', text: 'J' }, { value: 'K', text: 'K' }, { value: 'L', text: 'L' }, { value: 'M', text: 'M' }, { value: 'N', text: 'N' }, { value: 'O', text: 'O' }, { value: 'P', text: 'P' }, { value: 'Q', text: 'Q' }, { value: 'R', text: 'R' }, { value: 'S', text: 'S' }, { value: 'T', text: 'T' }, { value: 'U', text: 'U' }, { value: 'V', text: 'V' }, { value: 'W', text: 'W' }, { value: 'X', text: 'X' }, { value: 'Y', text: 'Y' }, { value: 'Z', text: 'Z' } ],
		storedControllingCombos: {}
	}
};

const getters = {
};

const mutations = {
  	resetState (state) {
    	Object.assign(state, getDefaultState())
  	},
		updateStoredControllingCombo (state, payload) {
			state.storedControllingCombo = payload;
		},
		addControllingCombo (state, payload) {
			// Check if payload has value unitId and controllingCombo
			if(!payload.unitId || !payload.controllingCombo) {
				return;
			}
			// Add controllingCombo to storedControllingCombo with unitId as key
			state.storedControllingCombos[payload.unitId] = payload.controllingCombo;
		},
};

const state = getDefaultState()

const actions = {
  resetState ({ commit }) {
    commit('resetState')
  },
	addControllingCombo ({ commit }, payload) {
		commit('addControllingCombo', payload);
	}
};

export default {
  	namespaced: true,
  	state,
  	getters,
  	actions,
  	mutations,
};